export const AoOosMessageKeys = [
  'COLLECTION_OUT_OF_STOCK',
  'COLLECTION_NOT_AVAILABLE',
  'COLLECTION_OUT_OF_STOCK_TU',
  'DELIVERY_OUT_OF_STOCK',
  'DELIVERY_NOT_AVAILABLE',
  'DELIVERY_NOT_AVAILABLE_AT',
  'DELIVERY_OUT_OF_STOCK_TU',
  'FT_6_DELIVERY',
  'FT_6_COLLECTION',
  'FT_27_DELIVERY',
  'FT_27_COLLECTION',
  'FT_23_DELIVERY',
  'FT_23_COLLECTION',
  'FT_28_DELIVERY',
  'FT_28_COLLECTION',
  'FT_29_DELIVERY',
  'FT_29_COLLECTION'
]
